var map = {
	"./apps/apps.module": [
		"./src/app/apps/apps.module.ts",
		"default~apps-apps-module~extra-component-extra-component-module",
		"common",
		"apps-apps-module"
	],
	"./apps/email/mail.module": [
		"./src/app/apps/email/mail.module.ts",
		"common",
		"apps-email-mail-module"
	],
	"./authentication/authentication.module": [
		"./src/app/authentication/authentication.module.ts",
		"common",
		"authentication-authentication-module"
	],
	"./charts/charts.module": [
		"./src/app/charts/charts.module.ts",
		"default~charts-charts-module~dashboards-dashboard-module~table-tables-module",
		"default~charts-charts-module~dashboards-dashboard-module",
		"charts-charts-module"
	],
	"./component/component.module": [
		"./src/app/component/component.module.ts",
		"default~component-component-module~table-tables-module",
		"common",
		"component-component-module"
	],
	"./dashboards/dashboard.module": [
		"./src/app/dashboards/dashboard.module.ts",
		"default~charts-charts-module~dashboards-dashboard-module~table-tables-module",
		"default~charts-charts-module~dashboards-dashboard-module",
		"default~dashboards-dashboard-module~table-tables-module",
		"dashboards-dashboard-module"
	],
	"./extra-component/extra-component.module": [
		"./src/app/extra-component/extra-component.module.ts",
		"default~apps-apps-module~extra-component-extra-component-module",
		"extra-component-extra-component-module"
	],
	"./form/forms.module": [
		"./src/app/form/forms.module.ts",
		"default~form-forms-module~ngx-wizard-ngx-wizard-module",
		"form-forms-module"
	],
	"./home/home.module": [
		"./src/app/home/home.module.ts",
		"home-home-module"
	],
	"./icons/icons.module": [
		"./src/app/icons/icons.module.ts",
		"icons-icons-module"
	],
	"./logistic/logistic.module": [
		"./src/app/logistic/logistic.module.ts",
		"logistic-logistic-module"
	],
	"./ngx-wizard/ngx-wizard.module": [
		"./src/app/form/ngx-wizard/ngx-wizard.module.ts",
		"default~form-forms-module~ngx-wizard-ngx-wizard-module"
	],
	"./people/people.module": [
		"./src/app/people/people.module.ts",
		"people-people-module"
	],
	"./products/products.module": [
		"./src/app/products/products.module.ts",
		"products-products-module"
	],
	"./reportIssue/reportIssue.module": [
		"./src/app/reportIssue/reportIssue.module.ts",
		"reportIssue-reportIssue-module"
	],
	"./reports/reports.module": [
		"./src/app/reports/reports.module.ts",
		"reports-reports-module"
	],
	"./sales/sales.module": [
		"./src/app/sales/sales.module.ts",
		"sales-sales-module"
	],
	"./sample-pages/sample-pages.module": [
		"./src/app/sample-pages/sample-pages.module.ts",
		"sample-pages-sample-pages-module"
	],
	"./starter/starter.module": [
		"./src/app/starter/starter.module.ts",
		"starter-starter-module"
	],
	"./table/tables.module": [
		"./src/app/table/tables.module.ts",
		"default~charts-charts-module~dashboards-dashboard-module~table-tables-module",
		"default~component-component-module~table-tables-module",
		"default~dashboards-dashboard-module~table-tables-module",
		"table-tables-module"
	],
	"./widgets/widgets.module": [
		"./src/app/widgets/widgets.module.ts",
		"widgets-widgets-module"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./src/$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;